// extracted by mini-css-extract-plugin
export default {"bodyText":"BodyText_bodyText__SUWwz","truncate":"BodyText_truncate__kcTy9"};